import {
  DefaultMetricOptions,
  GoalMetric,
  metricUnitFormatBase,
  NumberFormat,
} from '@griply/types';

import { formatNumberShort } from '../format-number-short';
import { isNumber } from '../is-number';

export enum GoalTargetLabelKind {
  Value = 'value',
  CompletedTasks = 'completed-tasks',
  SubGoalProgress = 'subgoal-progress',
  CompletedSubGoals = 'completed-subgoals',
  None = 'none',
}

export type GoalTargetLabel =
  | { kind: GoalTargetLabelKind.Value; text: string }
  | { kind: Exclude<GoalTargetLabelKind, GoalTargetLabelKind.Value> };

export type GetGoalTargetLabelOptions = {
  unitFormat?: string;
  numberFormat?: NumberFormat;
};

export const getGoalTargetLabel = (
  metric: GoalMetric | null | undefined,
  { unitFormat, numberFormat }: GetGoalTargetLabelOptions,
): GoalTargetLabel => {
  if (!metric?.id) {
    return { kind: GoalTargetLabelKind.None };
  }

  if (metric.id === DefaultMetricOptions.CompletedTasks) {
    return { kind: GoalTargetLabelKind.CompletedTasks };
  }

  if (metric.id === DefaultMetricOptions.SubGoalProgress) {
    return { kind: GoalTargetLabelKind.SubGoalProgress };
  }

  if (metric.id === DefaultMetricOptions.CompletedSubGoals) {
    return { kind: GoalTargetLabelKind.CompletedSubGoals };
  }

  if (!isNumber(metric.targetValue) || !unitFormat) {
    return { kind: GoalTargetLabelKind.None };
  }

  return {
    kind: GoalTargetLabelKind.Value,
    text: unitFormat.replace(
      metricUnitFormatBase,
      formatNumberShort(metric.targetValue, numberFormat?.decimal),
    ),
  };
};
